import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as EventsActions from './events.actions';
import { EVENTS } from './events.mock';

@Injectable()
export class EventsEffects {
  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventsActions.init),
      map(() => EventsActions.loadEventsSuccess({ events: EVENTS })),
      catchError((error: unknown) => {
        console.error('Error', error);
        return of(EventsActions.loadEventsFailure({ error }));
      })
    )
  );

  constructor(private actions$: Actions) {}
}
